import { z } from 'zod';

export const LoginModel = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  username: z.string().min(1),
  access: z.string().min(1),
  refresh: z.string().min(1),
});

/**
 * NOTES:
 * Allow simple string for LoginForm because to avoid an issue if a user cannot log in when password policy is changed.
 */
export const LoginFormSchema = LoginModel.pick({
  email: true,
}).extend({
  password: z.string().min(1),
});
